import Cookies from "js-cookie";
import axios from "axios";
import dayjs from "dayjs";
import { get } from "lodash";

const axiosServices = axios.create({ baseURL: import.meta.env.REACT_APP_BASE_URL });

// get from env
export const currentClientVersion = import.meta.env.REACT_APP_UI_VERSION;

const isTokenExpired = () => {
  try {
    const userString = localStorage.getItem("user");
    if (!userString) {
      return {
        token: null,
        res: true
      };
    }

    const user = JSON.parse(userString);
    const tokenExpiration = get(user, "data[0].accessToken.expiresOn");
    const token = get(user, "data[0].accessToken.token");

    if (!tokenExpiration) {
      return {
        token,
        res: true
      };
    }

    const expirationTime = new Date(tokenExpiration);
    const date1 = dayjs(expirationTime);
    const date2 = dayjs(new Date());

    const tokenExpired = date1.diff(date2) <= 0;
    return {
      res: tokenExpired,
      token
    };
  } catch (error) {
    // If parsing fails, assume token is expired to be safe
    console.error("Error checking token expiry:", error);
    return {
      token: null,
      res: true
    };
  }
};

const isAuthUrl = (config) => {
  return (
    [
      "/auth/login",
      "/auth/login/",
      "/auth/token",
      "/auth/token/",
      "/auth/status",
      "/auth/status/",
      "/preregsendemailotp/",
      "/preregsendemailotp",
      "/auth/resetpassword/",
      "/auth/resetpassword",
      "/auth/resendmsisdncode/",
      "/auth/resendemailcode/",
      "auth/resendemailcode",
      "/auth/preregsendphoneotp/",
      "/auth/preregsendemailot/",
      "/auth/validate/",
      "/auth/validate",
      "/auth/validatephoneotp/",
      "/auth/validatephoneotp/",
      "/auth/prevalidate/",
      "/options/",
      "/clients/register",
      "/auth/resetpassword/validatelink/",
      "/auth/status/email/",
      "/auth/resetpassword/email/",
      "/auth/resetpassword/email"
    ].some((url) => config.url.includes(url)) && ["get", "post", "put"].includes(config.method)
  );
};

axiosServices.interceptors.request.use((config) => {
  if (isAuthUrl(config)) {
    return config;
  }
  const bearerToken = localStorage.getItem("bearerToken");
  const { res, token } = isTokenExpired();
  if (!res) {
    const tokenToUse = bearerToken || token;
    if (tokenToUse) {
      config.headers.Authorization = `Bearer ${tokenToUse}`;
    }
  } else {
    window.location.pathname = "/login";
    localStorage.removeItem("user");
    localStorage.removeItem("bearerToken");
    Cookies.remove("popUpCount");
  }
  return config;
});

// Compare versions function
const compareVersions = (current, latest) => {
  const currentParts = current.split(".").map(Number);
  const latestParts = latest.split(".").map(Number);

  for (let i = 0; i < latestParts.length; i++) {
    if (currentParts[i] < latestParts[i]) return -1;
    if (currentParts[i] > latestParts[i]) return 1;
  }

  return 0;
};

// Intercept responses to handle Errors and Version Check
axiosServices.interceptors.response.use(
  (response) => {
    const serverClientVersion = response.headers["client_web_ui_version"];
    if (serverClientVersion && compareVersions(currentClientVersion, serverClientVersion) === -1) {
      window.location.reload();
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 500 && !isAuthUrl(error.config)) {
      window.location.pathname = "/500";
      // console.log("500 error", error.response);
    }
    return Promise.reject((error.response && error.response.data) || "Wrong Services");
  }
);

export default axiosServices;
